export function generateTemplate(columns) {
  return columns.map(column => column.width || 'minmax(max-content, 1fr)').join(' ');
}